//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    radioValue: {
      type: [String, Number, Boolean],
      required: true
    },
    theme: {
      type: String,
      default: ''
    },
  },
  computed: {
    radioButtonValue: {
      get() {
        return this.radioValue
      },
      set() {
        this.$emit("input", this.radioValue)
      }
    }
  }
}
